// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { intlFormatDistance as fn } from "../intlFormatDistance.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const intlFormatDistance = convertToFP(fn, 2);

// Fallback for modularized imports:
export default intlFormatDistance;
